import { createReducer, on } from '@ngrx/store';
import { CategoryResolvedConfigurationApiActions } from './category-resolved-configuration.actions';
import { adapter, initialState } from './category-resolved-configuration.state';

export const categoryResolvedConfigurationReducer = createReducer(
  initialState,
  on(CategoryResolvedConfigurationApiActions.categoryResolvedConfigurationLoaded, (state, { configuration }) => {
    return adapter.setOne(configuration, state);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCategoryResolvedConfigurationIds = selectIds;

export const selectCategoryResolvedConfigurationEntities = selectEntities;

export const selectAllCategoryResolvedConfigurations = selectAll;
